<template>
  <div class="before-login">
    <div class="login-logo"></div>
    <div class="tip_text">请选择您的登录身份</div>
    <div class="choice_options opction1" @click="onChoiceType(1)">
      <p class="left_info1"></p>
      <p class="center_info center_info_1">
        <span class="span1">我是员工</span>
        <span class="span2">运营子账号登录</span>
      </p>
      <p class="right_info"></p>
    </div>
    <!--<div class="choice_options opction2" @click="onChoiceType(2)">-->
      <!--<p class="left_info2"></p>-->
      <!--<p class="center_info center_info_2">-->
        <!--<span class="span1">我是员工</span>-->
        <!--<span class="span2">运营子账号登录</span>-->
      <!--</p>-->
      <!--<p class="right_info"></p>-->
    <!--</div>-->
  </div>
</template>

<style lang="scss">
.before-login {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 70px 45px 0 45px;
  background: #fff;
  .login-logo {
    width: 150px;
    height: 38px;
    margin: 0 auto 66px;
    background: url('../../assets/logo.jpg') no-repeat;
    background-position: 0 0;
    background-size: contain;
  }
  .tip_text {
    font-size: 16px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
  }
  .choice_options {
    height: 94px;
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    padding: 24px;
    align-items: center;
    cursor: pointer;
    .left_info1 {
      margin: 0px 24px 0 8px;
      width: 40px;
      height: 40px;
      background: url('../../assets/store.png') no-repeat;
      background-size: 40px 40px;
    }
    .left_info2 {
      margin: 0px 24px 0 8px;
      width: 40px;
      height: 40px;
      background: url('../../assets/user.png') no-repeat;
      background-size: 40px 40px;
    }
    .center_info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 38px;
      .span1 {
        text-align: left;
        font-size: 20px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      .span2 {
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .center_info_1 {
      margin-right: 38px;
    }
    .center_info_2 {
      margin-right: 20px;
    }
    .right_info {
      width: 20px;
      height: 20px;
      background: url('../../assets/right.png') no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .opction1 {
    background: rgba(255, 128, 0, 1);
    margin: 32px 0px;
  }
  .opction2 {
    background: rgba(25, 137, 250, 1);
  }
}
</style>

<script>
export default {
  name: 'beforeLogin',
  data() {
    return {};
  },
  mounted() {},

  methods: {
    onChoiceType(type) {
      this.$emit('getChoiceType', type);
    }
  },
  components: {}
};
</script>
